export default __webpack_public_path__ + "static/media/guasasapotv.af2b5cc6.png";